import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-weight-penalty',
  templateUrl: './jockey-weight-penalty.component.html',
  styleUrls: ['./jockey-weight-penalty.component.scss']
})
export class JockeyWeightPenaltyComponent implements OnInit {

  @ViewChild('jockeyPenalty') jockeyPenaltyElement: ElementRef;
  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  disableReadScale = false;
  userId: number;
  jockeyPenalty: {
    penaltyWeight: number
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    };
    this.jockeyPenalty = {
      penaltyWeight: null
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    this.jockeyPenaltyElement.nativeElement.focus();
  }

  checkWeight(newValue): void {
    this.jockeyPenalty.penaltyWeight = newValue;
    this.meta.enableSave = newValue >= 0 && newValue <= 10;
  }

  resetWeighOut() {
    return new Promise((resolve, reject) => {
      const payload = {
        animalId: this.jockey.animalId,
        jockeyId: Number(this.jockey.jockeyId),
        yearOfRace: this.jockey.yearOfRace,
        raceId: this.jockey.raceId,
        divisionSequence: this.jockey.divisionSequence,
        weightDisplayed: null,
        jockeyOverweight: null,
        raw: null,
        weighed: 'O',
        type: 'M',
        updatedBy: this.userId
      };
      console.log(`[ DEBUG ] Resetting weigh-out:`, payload);
      this.apiService.updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
        .subscribe(
          res => resolve(res),
          err => reject(err)
        );
    });
  }

  confirm(reset: boolean = false) {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      // jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      penaltyWeight: reset ? null : this.jockeyPenalty.penaltyWeight,
      updatedBy: this.userId
    };
    this.apiService.updateJockeyClaim(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        resJockeyClaim => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.notification.success(`${this.jockey.animalName} weight penalty has been saved.`, 'Weight Penalty');
          if (this.jockey.weights['O'].weightRecorded) {
            this.notification.warning(`${this.jockey.jockeyName} was already weighted out. ` +
            `Please weight it out again with the updated weight.`, 'Weigh-Out', { timeOut: 6000 });
            this.resetWeighOut()
            .then(resWeighOut => {
              resJockeyClaim.resetWeighOut = true;
              this.meta.saving = false;
              this.activeModal.close(resJockeyClaim);
            })
            .catch(errWeighOut => {
              console.error('[ DEBUG ] Error resetting weigh-out after changing Jockey', errWeighOut);
              this.meta.saving = false;
              resJockeyClaim.resetWeighOut = false;
              this.activeModal.close(resJockeyClaim);
              this.notification.error(`Could't reset the weigh-out of the Jockey. Please remember to weigh-out again.`,
              'Weigh-Out', { disableTimeOut: true });
            });
          } else {
            this.meta.saving = false;
            this.activeModal.close(resJockeyClaim);
          }
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the weight penalty. Check your connection and Try again.`, 'Weight Penalty');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
